import { TDatabaseId } from '@infotech-soe/metaschema';
import { Set as ImmutableSet } from 'immutable';

import { RefreshStrategy } from '../CategoryCommand';

export interface MoveRefreshStrategyBuilderArgs {
  args: any;
  checkedTreeIds: ImmutableSet<TDatabaseId>;
  activeId: TDatabaseId | null;
  targetTreeId: TDatabaseId;
}

export default ({
  checkedTreeIds,
  activeId,
  targetTreeId,
}: MoveRefreshStrategyBuilderArgs): RefreshStrategy => {
  if (!checkedTreeIds.isEmpty() && checkedTreeIds.has(targetTreeId)) {
    return RefreshStrategy.CURRENT;
  }

  if (
    (!checkedTreeIds.isEmpty() && !checkedTreeIds.has(targetTreeId)) ||
    activeId !== targetTreeId
  ) {
    return RefreshStrategy.REMOVE;
  }

  return RefreshStrategy.CURRENT;
};
